var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconPencil = function SvgIconPencil(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.231 3.00441L10.1113 0.873851C9.97124 0.734486 9.78169 0.65625 9.58409 0.65625C9.3865 0.65625 9.19694 0.734486 9.05687 0.873851L1.54215 8.37774L0.856037 11.3389C0.832368 11.4471 0.83318 11.5593 0.858412 11.6672C0.883644 11.775 0.932659 11.8759 1.00188 11.9625C1.07109 12.049 1.15877 12.1189 1.25849 12.1672C1.35821 12.2155 1.46746 12.241 1.57826 12.2416C1.62989 12.2468 1.68191 12.2468 1.73354 12.2416L4.72715 11.5555L12.231 4.05885C12.3704 3.91878 12.4486 3.72922 12.4486 3.53163C12.4486 3.33404 12.3704 3.14448 12.231 3.00441ZM4.36604 10.9055L1.5602 11.4941L2.19937 8.74246L7.82187 3.14163L9.98854 5.3083L4.36604 10.9055ZM10.4724 4.78468L8.30576 2.61802L9.56242 1.36857L11.693 3.53524L10.4724 4.78468Z",
    fill: "#666C95"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconPencil, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-pencil.cdb4b0d6.svg";
export { ForwardRef as ReactComponent };